import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// check mount path of oora.traffic.peak.route.js
const API = `${BASE_URL}/oora-peak`;

const config = {
  headers: { "Content-Type": "application/json" },
};

// body = { page, limit, search, date_label, slot, traffic_level, kind }
export const getOoraTomtomTrafficList = (formData, showLoader = true) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_OORA_TOMTOM_TRAFFIC_LIST_REQUEST" });
      const { data } = await axios.post(`${API}/list`, formData, config);
      if (data.statusCode === 200) {
        dispatch({ type: "GET_OORA_TOMTOM_TRAFFIC_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_OORA_TOMTOM_TRAFFIC_LIST_FAILED", payload: data });
      }
      return data;
    } catch (error) {
      dispatch({ type: "GET_OORA_TOMTOM_TRAFFIC_LIST_FAILED", payload: error.message });
    } finally {
      if (showLoader) {
        dispatch({ type: "STOP_LOADING" });
      }
    }
  };
};

export const viewOoraTomtomTraffic = (id, showLoader = true) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_OORA_TOMTOM_TRAFFIC_REQUEST" });
      const { data } = await axios.post(`${API}/view`, { id }, config);
      if (data.statusCode === 200) {
        dispatch({ type: "GET_OORA_TOMTOM_TRAFFIC_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_OORA_TOMTOM_TRAFFIC_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({ type: "GET_OORA_TOMTOM_TRAFFIC_FAIL", payload: error.message });
    } finally {
      if (showLoader) {
        dispatch({ type: "STOP_LOADING" });
      }
    }
  };
};